<template>
  <div class="page-container">
    <header class="nudge-pay-header">
      <img src="@/assets/images/logo/tracking-logo.png" alt="Nudg Pay Logo" />
    </header>

    <div
      v-show="activeBookingDiv || dispatchedBookingDiv || advancedBookingDiv"
      class="booking-details-container"
    >
      <div class="booking-details-card">
        <div class="booking-status-row">
          <h3 class="booking-title">Booking Details</h3>
          <button :class="statusButtonClass">
            {{
              bookingStatus === "active"
                ? "Searching"
                : bookingStatus === "booked"
                ? "Advance"
                : capitalizeFirstLetter(bookingStatus)
            }}
          </button>
        </div>
        <div v-show="activeBookingDiv" class="searching-box">
          <span class="search-icon">
            <img
              class="search-icon-img"
              src="@/assets/images/search.png"
              alt="Searching Icon"
            />
          </span>
          <div class="searching-text">We’re Searching Nearby Driver</div>
        </div>

        <div v-show="activeBookingDiv || advancedBookingDiv">
          <div class="vehicle-info-row">
            <p>Price</p>
            <p>
              <strong>  £ {{ bookingInfo.price }} {{ cashMeterJob? 'Approx.' : '' }}</strong>
            </p>
          </div>
          <div class="vehicle-info-row">
            <p>Date & Time</p>
            <p>
              <strong>{{ bookingInfo.bookedAtTime }}</strong>
            </p>
          </div>
          <div class="vehicle-info-row">
            <p>Payment</p>
            <p class="payment-color">{{ bookingInfo.paymentType }}/{{bookingInfo.paymentStatus}}</p>
          </div>
        </div>
        <div v-show="dispatchedBookingDiv">
          <div class="booking-details-header">
            <div class="driver-info">
              <img
                class="driver-avatar"
                src="@/assets/images/driver.png"
                alt="Driver Avatar"
              />
              <div class="driver-details">
                <p class="driver-name">{{ driverInfo.name }}</p>
                <div class="driver-rating">
                  <img
                    class="star-icon"
                    src="@/assets/images/star-favorite.png"
                    alt="Star Icon"
                  />
                  <span class="ml-1">{{ driverInfo.rating }}</span>
                </div>
              </div>
            </div>
            <div class="driver-actions">
              <button class="contact-button" @click.prevent="callDriver()">
                <img src="@/assets/images/phone-icon.png" alt="Call Driver" />
              </button>
              <!-- <button class="share-button" @click.prevent="shareContent()">
                <img src="@/assets/images/share-icon.png" alt="Share Info" />
              </button> -->
            </div>
          </div>

          <div class="vehicle-info-row">
            <p>{{ carInfo.name }} - {{ carInfo._color }}</p>
            <p class="license-plate">{{ carInfo.numberPlate }}</p>
          </div>

          <div class="ride-info-row">
            <div v-show="showETA" class="eta">
              <p class="ride-info-heads">ETA</p>
              <p>
                <strong>{{ bookingInfo.eta }}</strong>
              </p>
            </div>
            <div class="distance">
              <p class="ride-info-heads">Distance</p>
              <p>
                <strong>{{ bookingInfo.distance }} mi</strong>
              </p>
            </div>
            <div class="price">
              <p class="ride-info-heads">Price</p>
              <p>
                <strong>£ {{ bookingInfo.price }} {{ cashMeterJob? 'Approx.' : '' }}</strong>
              </p>
            </div>
          </div>
        </div>

        <div class="locations">
          <div class="location-row">
            <div class="pickup-row">
              <span class="location-icon">
                <img
                  class="location-icon-img"
                  src="@/assets/images/blue-circle.png"
                  alt="Pickup Icon"
                />
              </span>
              <span class="location-type">Pickup</span>
              <span class="separator">|</span>
              <span class="location-address">{{ bookingInfo.pickup }}</span>
            </div>
          </div>

          <div class="location-row">
            <div class="dropoff-row">
              <span class="location-icon">
                <img
                  class="location-icon-img"
                  src="@/assets/images/green-vector.png"
                  alt="Dropoff Icon"
                />
              </span>
              <span class="location-type">Dropoff</span>
              <span class="separator">|</span>
              <span class="location-address">{{
                bookingInfo.destination
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="map-container">
        <GmapMap
          :center="mapCenter"
          :zoom="mapZoom"
          ref="gmap"
          style="width: 100%; height: 500px; border-radius: 15px"
          :options="mapOptions"
        >
          <GmapMarker :icon="PickupIcon" v-if="origin" :position="origin"></GmapMarker>
          <GmapMarker
          :icon="DestinationIcon"
            v-if="destination"
            :position="destination"

          ></GmapMarker>
          <GmapMarker
            v-if="vehicleAssigned && vehiclePosition && vehiclePosition.lat != null && vehiclePosition.lng != null && !isNaN(vehiclePosition.lat) && !isNaN(vehiclePosition.lng)"
            :icon="carIcon"
            :position="vehiclePosition"
          ></GmapMarker>
          <GmapPolyline
            v-if="route"
            :path="route"
            strokeColor="#0000FF"
            strokeOpacity="1.0"
            strokeWeight="2"
          ></GmapPolyline>
        </GmapMap>
      </div>
    </div>
    <div v-show="archivedBookingDiv">
      <div class="h-screen flex w-full bg-img">
        <div
          class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
        >
          <img
            src="@/assets/images/pages/404.png"
            alt="graphic-404"
            class="mx-auto mb-4 max-w-full"
          />
          <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
            404 - Page Not Found!
          </h1>
          <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse">
            The Booking you are looking for is not available for tracking
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WEB_SERVER_HOST } from "@/environment/index";
import Echo from "laravel-echo";
window.io = require("socket.io-client");

window.Echo = new Echo({
  broadcaster: "socket.io",
  host: WEB_SERVER_HOST,
  authEndpoint: "/broadcasting/auth",
});

import { ride_details, locate_vehicle } from "@/services/Tracking";

export default {
  name: "LiveTracking",

  data() {
    return {
      bid: this.$route.params.bid,
      apiBookingId: null,
      bookingData: {},
      provider : null,

      // map data start
      mapCenter: { lat: 52.954783, lng: -1.158109 }, // Center of Nottingham as an example
      origin: null,
      destination: null,
      route: null,
      mapOptions: {
        mapTypeId: "roadmap",
      },

      // map data ends
      bookingInfo: {
        bookedAtTime: null,
        pickupDateTime: "",
        price: "",
        eta: "",
        distance: "",
        pickup: "",
        destination: "",
        paymentType: "Cash",
      },
      pickupText: "",
      destinationText: "",
      driverInfo: {
        name: "",
        rating: "0.0",
        phone: "",
        photo: "",
      },
      carInfo: {
        numberPlate: "",
        _color: "",
        name: "",
      },

      bookingStatus: "",
      directionsService: null,
      directionsDisplay: null,
      mapZoom: 10, // Default zoom level


      lastPosition: {},
      numDeltas: 100,
      delay: 10, // milliseconds
      i: 0,

      activeBookingDiv: false,
      archivedBookingDiv: false,
      dispatchedBookingDiv: false,
      advancedBookingDiv: false,

      vehiclePosition: {
        lat: null,
        lng: null,
        heading: 0,
      },
      newVehiclePositionDestination: null, // Target destination to move towards

      DestinationIcon: require('@/assets/images/logo/green-filled-marker.svg'),
      PickupIcon: require('@/assets/images/pickup-marker.svg'),
      vehicleAssigned: false,
      vehicleId: null,
      vehicleConnectionSetup:false,
      getVehiclePositionCalled: false,
      paymentStatus: 'UnPaid',
      carIcon: {
        url: require('@/assets/car.svg'),
        scaledSize: { width: 50, height: 50 },
        anchor: { x: 25, y: 25 },
        rotation: 0, // Initial rotation
      },
      showETA: true,
      a: null,
      b:null,
      bookingChannelId: null, // currently connected booking channel id
      vehicleChannelId: null, // currently connected vehicle channel id
      cashMeterJob: false,
   };
  },
  computed: {
    statusButtonClass() {
      const statusClasses = {
        dispatched: "accepted-button",
        pickedup: "accepted-button",
        arrived: "accepted-button",
        complete: "accepted-button",
        booked: "advance-button",
        active: "advance-button",
        offered: "advance-button",
        searching: "searching-status-btn",
        archived: "archived-button",
        cancelled: "archived-button",
      };
      return statusClasses[this.bookingStatus] || "default-button";
    },
  },

  mounted() {
    document.title = "Nudg Tracking";
    const favicon = document.getElementById("favicon");

    if (favicon) {
      favicon.href =  `${process.env.BASE_URL}nudgtrack-favicon.ico`;//require("@/assets/images/logo/nudgtrack-favicon.ico");
    }
    this.initMap();
  },

  beforeDestroy() {
    // Clean up socket connections when component is destroyed
    if (this.apiBookingId) {
      window.Echo.leave(`booking.${this.apiBookingId}`);
    }
    if (this.vehicleId) {
      window.Echo.leave(`booking-vehicle.${this.vehicleId}`);
    }
  },
  watch: {
    // Watch for changes in bookingStatus
    bookingStatus(newStatus) {
      // Set showETA to false for certain statuses
      if (["pickedup", "arrived", "complete", "completed"].includes(newStatus)) {
        this.showETA = false;
      }
      else {
        this.showETA = true;
      }
      if(newStatus == 'complete')
        this.leaveChannel('vehiclePosition');

    // Reset all booking div states to false
      this.dispatchedBookingDiv = false;
      this.activeBookingDiv = false;
      this.archivedBookingDiv = false;
      this.advancedBookingDiv = false;

      // Update the specific div based on the new status
      switch (newStatus) {
        case "active":
        case "offered": 
          this.activeBookingDiv = true;
          break;
        case "cancelled":
        case "complete":
        case "completed":
          if(this.vehicleConnectionSetup) {
            this.leaveChannel('vehiclePosition');
          }
          this.redirectToPreviousPage();

          this.archivedBookingDiv = true;
          break;
        case "booked":
          this.advancedBookingDiv = true;
          break;
        case "dispatched":
        case "arrived":
        case "pickedup":

          if(!this.getVehiclePositionCalled && this.vehicleId)
            {this.getVehiclePosition();}
          this.dispatchedBookingDiv = true;
          this.vehicleAssigned = true;
          break;
        default:
          console.log('defaulter case of booking status');
          break;
      }
    },
  },
  methods: {
    redirectToPreviousPage() {
      // get the url and remove live-track from the url load the previous page
      const url = window.location.href;
      const urlWithoutLiveTrack = url.replace('/live-track', '');
      window.location.href = urlWithoutLiveTrack; 
    },
    leaveChannel(channelName) {
        if(channelName == 'vehiclePosition') {
          this.vehicleAssigned = false;
          window.Echo.leave(`booking-vehicle.${this.vehicleId}`);
        }
    },
    getVehiclePosition(){
      locate_vehicle(this.apiBookingId,this.vehicleId).then(res => {
        console.log(res);
        this.getVehiclePositionCalled = true;
        this.setInitialPosition(res.data);
        console.log(this.vehicleConnectionSetup);
        console.log('this.vehicleConnectionSetup');
        console.log(this.vehicleId);
        console.log('this.vehicleId');
        if(!this.vehicleConnectionSetup) {
          this.setupSocketConnectionForVehicle(this.vehicleId);
        }
      });
    },

    initMap() {
      this.$vs.loading({ text: "Fetching data......" });
      this.fetchRideDetails();
    },

    setVehicleId(id) {
      this.vehicleId = id;
    },

    setVehiclePosition(position) {
      console.log('setVehiclePosition');
      console.log(position);
      
      // Validate that lat and lng are valid numbers
      const lat = parseFloat(position.lat);
      const lng = parseFloat(position.lng);
      
      if (isNaN(lat) || isNaN(lng)) {
        console.error('Invalid position data:', position);
        return;
      }
      
      this.vehiclePosition.lat = lat;
      this.vehiclePosition.lng = lng;
      this.vehiclePosition.heading = position.heading || 0;
    },

    setZoomBasedOnDistance() {
     const originLatLng1 = new google.maps.LatLng(
        this.origin.lat,
        this.origin.lng
      );
      const destinationLatLng1 = new google.maps.LatLng(
        this.destination.lat,
        this.destination.lng
      );
      const distanceInMeters =
        google.maps.geometry.spherical.computeDistanceBetween(
          originLatLng1,
          destinationLatLng1
        );
      // Adjust zoom based on the calculated distance (you can fine-tune these numbers)
      if (distanceInMeters < 500) {
        this.mapZoom = 16; // For very short distances
      } else if (distanceInMeters < 3000) {
        this.mapZoom = 15; // Short distances
      }  else if (distanceInMeters < 5000) {
        this.mapZoom = 14; // Short distances
      } else if (distanceInMeters < 20000) {
        this.mapZoom = 12; // Short distances
      } else if (distanceInMeters < 50000) {
        this.mapZoom = 10; // Medium distances
      } else {
        this.mapZoom = 8; // Long distances
      }

      // Center the map between the two markers
      this.mapCenter = {
        lat: (this.origin.lat + this.destination.lat) / 2,
        lng: (this.origin.lng + this.destination.lng) / 2,
      };
    },

    formatTime(estimatedTime) {
      // Split the time string by colon to extract hours, minutes, seconds, and milliseconds
      let [hours, minutes, seconds] = estimatedTime.split(":");

      // Further split seconds to separate the milliseconds (if needed)
      seconds = seconds.split(".")[0]; // Get rid of the milliseconds part

      // Convert hours, minutes, and seconds to numbers
      hours = parseInt(hours, 10);
      minutes = parseInt(minutes, 10);
      seconds = parseInt(seconds, 10);

      // Create a readable string based on the available data
      let humanReadable = "";
      if (hours > 0) {
        humanReadable += `${hours} hour${hours > 1 ? "s" : ""} `;
      }
      if (minutes > 0) {
        humanReadable += `${minutes} minute${minutes > 1 ? "s" : ""} `;
      }
      if (seconds > 0) {
        humanReadable += `${seconds} second${seconds > 1 ? "s" : ""}`;
      }

      return humanReadable.trim();
    },

    ensureMinutes(eta) {
      if (eta === null || eta === undefined) {
        return "";
      }

      const text = String(eta).trim();
      if (!text) {
        return "";
      }

      return /\bminutes?\b/i.test(text) ? text : `${text} minutes`;
    },


    fetchRideDetails() {
      ride_details(this.bid)
        .then((response) => {
          if (response.data.obj == null) {
            // means we've archived booking
            this.$vs.loading.close();
            this.dispatchedBookingDiv = false;
            this.activeBookingDiv = false;
            this.$router.push("/p/"+this.bid).catch(() => {});

            // this.archivedBookingDiv = true;
            return;
          }
          this.apiBookingId = response.data.obj.api_booking_Id;
          const data = response.data.obj.booking;
          const responseObj = response.data.obj;
          this.provider = response.data.obj.booking_provider;
          this.bookingData = data;

          this.setupSocketConnectionForBookingStatus(this.apiBookingId);
          this.bookingStatus = responseObj.booking_status;
          this.bookingInfo.pickup = responseObj.pickup;
          this.bookingInfo.destination = responseObj.destination;
          this.bookingInfo.price = responseObj.price;
          this.bookingInfo.distance = responseObj.distance;
          this.bookingInfo.pickupDateTime = responseObj.pickup_due_time;
          this.bookingInfo.eta = this.ensureMinutes(responseObj.eta);
          this.bookingInfo.bookedAtTime = responseObj.bookedAtTime;
          this.bookingInfo.paymentType = responseObj.paymentType;
          this.bookingInfo.paymentStatus = this.capitalizeFirstLetter(responseObj.payment_status);

          if(this.provider == 'infocab') {
            if(data.pricing.fareType == 'Meter'){
              this.cashMeterJob = true;
            }
          }
          // if booking status is not active
          this.driverInfo.name = responseObj.driver_name;
          this.driverInfo.phone = responseObj.driver_mobile;
          this.driverInfo.rating = responseObj.driver_rating;
          this.carInfo._color = responseObj.vehicle_color;
          this.carInfo.numberPlate = responseObj.vehicle_registration;
          this.carInfo.name = responseObj.vehicle_name;
          

          if (
            this.bookingStatus != "active" &&
            this.bookingStatus != "booked" &&
            this.bookingStatus != "offered"
          ) {
            if(this.provider === 'infocab') {
              this.vehicleId = responseObj.vehicle.infocab_vehicle_id;
            }
            else if(this.provider === 'autocab') {
              this.vehicleId = responseObj.vehicle.id;
            }
            else {
              this.vehicleId = null;
            }
          }

          const pickupLat = data.pickup.address.coordinate.latitude;
          const pickupLng = data.pickup.address.coordinate.longitude;
          const destinationLat = data.destination.address.coordinate.latitude;
          const destinationLng = data.destination.address.coordinate.longitude;

          this.mapCenter = {
            lat: (pickupLat + destinationLat) / 2,
            lng: (pickupLng + destinationLng) / 2,
          };

          this.origin = {
            lat: parseFloat(pickupLat),
            lng: parseFloat(pickupLng),
          };
          this.destination = {
            lat: parseFloat(destinationLat),
            lng: parseFloat(destinationLng),
          };
          this.directionsService = new google.maps.DirectionsService();
          this.directionsDisplay = new google.maps.DirectionsRenderer();
          const request = {
            origin: new google.maps.LatLng(
              data.pickup.address.coordinate.latitude,
              data.pickup.address.coordinate.longitude
            ),
            destination: new google.maps.LatLng(
              data.destination.address.coordinate.latitude,
              data.destination.address.coordinate.longitude
            ),
            travelMode: google.maps.TravelMode.DRIVING,
          };
          this.directionsService.route(request, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
              this.directionsDisplay.setDirections(result);
              this.directionsDisplay.setMap(this.map);

              if (
                ["dispatched", "arrived", "pickedup"].includes(
                  response.data.obj.booking_status
                )
              ) {
                var vehiclePos = response.data.obj.vehicleLocation;
                this.setInitialPosition({'lat':vehiclePos.latitude,'lng':vehiclePos.longitude,'heading':0});
                this.setupSocketConnectionForVehicle(this.vehicleId);
                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
              } else {
                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
              }
            }
          });
          this.setZoomBasedOnDistance();

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.error("Error fetching ride details:", error);
        });
    },
    callDriver() {
      window.location.href = "tel:+44"+this.driverInfo.phone;
    },

    setupSocketConnectionForBookingStatus(bookingId) {
      // Ignore if already connected to this booking channel
      if (this.bookingChannelId === bookingId) {
        return;
      }
      this.bookingChannelId = bookingId;
      window.Echo.channel(`booking.${bookingId}`).listen(
        "GeneralBookingEvent",
        (event) => {
          console.log("GeneralBookingEvent:", event);
            switch (event.change_type) {
             
             // todo in future check modified webhook send change_type as booking_details_modified
              case 'cost_modified':
                   window.location.reload();
              break;
              case 'booking_status':
                  this.updateBookingInfo(event.booking, event.request_payload);
              break;
              case 'payment_status':
                  this.updatePaymentStatus(event.request_payload);
              break;
              case 'booking_details_modified':
                  this.updateBookingDetails(event.request_payload);
              break;

              default:
                break;
            }
        }
      );
    },
    setInitialPosition(initialLocation) {
      this.setVehiclePosition(initialLocation);
    },

    setupSocketConnectionForVehicle(vehicleId) {
      // Ignore if already connected to this vehicle channel or no vehicleId yet
      if (!vehicleId) { return; }
      if (this.vehicleChannelId === vehicleId) { return; }
      this.vehicleChannelId = vehicleId;
      window.Echo.channel(`booking-vehicle.${vehicleId}`).listen(
        "VehiclePositionUpdated",
        (event) => {
          console.log('VehiclePositionUpdated');
          console.log(event);
          this.vehicleConnectionSetup = true
          const etaReceived = event.estimatedPickupTime;
          this.bookingInfo.eta = this.ensureMinutes(etaReceived);
          
          if (!this.vehiclePosition) {
            this.setVehiclePosition({
              lat: event.location.latitude,
              lng: event.location.longitude,
              heading: event.heading,
            });
          }
          else {
              this.updateVehiclePosition({
                  lat: event.location.latitude,
                  lng: event.location.longitude,
                  heading: event.heading,
              })
          }
        }
      );
    },
    updateBookingInfo(booking, requestData) {
      
        if(booking.status == 'complete' || booking.status == 'completed' || booking.status == 'cancelled') {
          this.bookingStatus = booking.status;
          this.leaveChannel('vehiclePosition');
          this.archivedBookingDiv = true;
          this.dispatchedBookingDiv = false;
          this.activeBookingDiv = false;
          this.advancedBookingDiv = false;
          return;
        }
      if(this.provider === 'autocab') {
        this.bookingStatus = booking.status;
          this.bookingInfo.distance = requestData.Distance;
          this.bookingInfo.eta = this.formatTime(
            requestData.PriceComparison.EstimatedTime
          );
          if(booking.driver) {
            this.driverInfo.name = booking.driver.first_name + " " + booking.driver.last_name;
            this.driverInfo.phone = booking.driver.mobile;
            this.driverInfo.rating = booking.driver.rating? booking.driver.rating: 0;
          }
          if(booking.vehicle) {
            this.vehicleId = booking.vehicle.autocab_vehicle_id
            this.carInfo._color = booking.vehicle.colour;
            this.carInfo.numberPlate = booking.vehicle.registration;
            this.carInfo.name = `${booking.vehicle.make || ''} ${booking.vehicle.model || ''}`;
          }

      }
      else if(this.provider === 'infocab') {
        console.log(requestData.data);
        
        if(requestData.data.jobStatus == 'ConfirmPending') {
          this.bookingStatus = 'offered';
        }
        else {
          this.bookingStatus = booking.status;
          this.bookingInfo.distance = booking.distance;
          const etaValue = booking.driver_vehicle_data && booking.driver_vehicle_data.pickupEstimatedTimeMinutes ? booking.driver_vehicle_data.pickupEstimatedTimeMinutes : 0;
          this.bookingInfo.eta = this.ensureMinutes(etaValue);
          if(booking.driver) {
            this.driverInfo.name = booking.driver_vehicle_data.driverFirstName + " " + booking.driver_vehicle_data.driverLastName;
            this.driverInfo.phone = booking.driver_vehicle_data.driverMobile;
            this.driverInfo.rating = booking.driver.rating? booking.driver.rating: 0;

          }
          if(booking.vehicle) {
            this.vehicleId = booking.driver_vehicle_data.vehicleId
            this.carInfo._color = booking.driver_vehicle_data.color;
            this.carInfo.numberPlate = booking.driver_vehicle_data.registrationNumber;
            this.carInfo.name = `${booking.driver_vehicle_data.make || ''} ${booking.driver_vehicle_data.model || ''}`;
          }
        }

       
      }
    },
    updatePaymentStatus(paymentData) {
      if(this.provider === 'infocab') {
        console.log("Payment status update received:", paymentData);
      
      // Update payment status based on the received data
        if (paymentData.paymentStatus) {
          // Use Vue.set to ensure reactivity
          this.$set(this.bookingInfo, 'paymentStatus', this.capitalizeFirstLetter(paymentData.paymentStatus));
          this.$set(this.bookingInfo, 'paymentType', 'CCPaid');
          
          // Show notification to user about payment status change
          this.$vs.notify({
            title: "Payment Status Updated",
            text: `Payment status changed to: ${this.bookingInfo.paymentStatus}`,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });
        }
      }
      else if(this.provider === 'autocab') {
        
        alert('autocab payment status update');
       }
       else {
         alert('other payment status update');
       }
     
    },

    updateBookingDetails(bookingData) {
      console.log("Booking details update received:", bookingData);
      
      // Validate that bookingData is an object
      if (!bookingData || typeof bookingData !== 'object' || Array.isArray(bookingData)) {
        console.error("Invalid booking data format:", bookingData);
        return;
      }

      if (this.provider === 'infocab') {
        // Update booking information based on the received data
        if (bookingData.status) {
          this.bookingStatus = bookingData.status;
        }

        if (bookingData.pickup) {
          this.$set(this.bookingInfo, 'pickup', bookingData.pickup);
        }

        if (bookingData.destination) {
          this.$set(this.bookingInfo, 'destination', bookingData.destination);
        }

        if (bookingData.price !== undefined && bookingData.price !== null) {
          this.$set(this.bookingInfo, 'price', bookingData.price);
        }

        if (bookingData.distance !== undefined && bookingData.distance !== null) {
          this.$set(this.bookingInfo, 'distance', bookingData.distance);
        }

        if (bookingData.eta) {
          this.$set(this.bookingInfo, 'eta', this.formatTime(bookingData.eta));
        }

        if (bookingData.bookedAtTime) {
          this.$set(this.bookingInfo, 'bookedAtTime', bookingData.bookedAtTime);
        }

        if (bookingData.pickupDateTime) {
          this.$set(this.bookingInfo, 'pickupDateTime', bookingData.pickupDateTime);
        }

        if (bookingData.paymentType) {
          this.$set(this.bookingInfo, 'paymentType', bookingData.paymentType);
        }

        if (bookingData.paymentStatus) {
          this.$set(this.bookingInfo, 'paymentStatus', this.capitalizeFirstLetter(bookingData.paymentStatus));
        }

        // Update pickup and destination locations if coordinates are provided
        if (bookingData.pickupCoordinates && this.origin) {
          this.$set(this.origin, 'lat', parseFloat(bookingData.pickupCoordinates.latitude));
          this.$set(this.origin, 'lng', parseFloat(bookingData.pickupCoordinates.longitude));
        }

        if (bookingData.destinationCoordinates && this.destination) {
          this.$set(this.destination, 'lat', parseFloat(bookingData.destinationCoordinates.latitude));
          this.$set(this.destination, 'lng', parseFloat(bookingData.destinationCoordinates.longitude));
        }

        // Show notification to user about booking details update
        this.$vs.notify({
          title: "Booking Updated",
          text: "Your booking details have been updated",
          iconPack: "feather",
          icon: "icon-info",
          color: "info",
        });

        // Update the map if coordinates changed
        if ((bookingData.pickupCoordinates && this.origin) || (bookingData.destinationCoordinates && this.destination)) {
          this.setZoomBasedOnDistance();

          // Redraw the route if both origin and destination are set
          if (this.directionsService && this.origin && this.destination) {
            const request = {
              origin: new google.maps.LatLng(this.origin.lat, this.origin.lng),
              destination: new google.maps.LatLng(this.destination.lat, this.destination.lng),
              travelMode: google.maps.TravelMode.DRIVING,
            };

            this.directionsService.route(request, (result, status) => {
              if (status === google.maps.DirectionsStatus.OK) {
                this.directionsDisplay.setDirections(result);
                this.directionsDisplay.setMap(this.map);

                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
              }
            });
          }
        }
      }
      else if (this.provider === 'autocab') {
        console.log("Booking details update received:", bookingData);
      }
      else {
        console.log("Booking details update received:", bookingData);
      }


    },

    updateVehiclePosition(location) {
      this.newVehiclePositionDestination = location;
      this.mapCenter = location
      this.moveCar();

    },
    moveCar() {
       if (!this.newVehiclePositionDestination) return;
      // Reset the step counter and calculate deltas
       this.i = 0;

      this.a = (this.newVehiclePositionDestination.lat - this.vehiclePosition.lat) / this.numDeltas;
      this.b = (this.newVehiclePositionDestination.lng - this.vehiclePosition.lng) / this.numDeltas;

      this.animateMarker(); // Start animating towards the destination
    },
    animateMarker() {

       if (this.i < this.numDeltas) {
        // Calculate the next position
        this.vehiclePosition = {
          lat: this.vehiclePosition.lat+this.a,
          lng: this.vehiclePosition.lng+this.b,
        };

 // Center the map on the car as it moves
        this.mapCenter = this.vehiclePosition;
        //  const angle = Math.atan2(this.b, this.a) * (180 / Math.PI);

        // // Update the icon with the new rotation angle
        // this.currentIcon = {
        //   ...this.currentIcon, // Spread existing properties
        //   rotation: angle,
        // };

        // this.testFunc();

        // Adjust zoom based on some criteria (optional)
        this.adjustZoom();
        this.i++;
        setTimeout(this.animateMarker, this.delay);
      } else {
        // Snap to the exact destination after animation completes
        this.vehiclePosition = { ...this.newVehiclePositionDestination };
      }

    },
    adjustZoom() {
      // Example logic to adjust zoom based on movement
      const distance = this.calculateDistance(this.vehiclePosition, this.newVehiclePositionDestination);

      // Adjust zoom level based on distance (use your criteria)
      if (distance > 0.1) {
        this.mapZoom = 12; // Zoom out if moving over a long distance
      } else {
        this.mapZoom = 15; // Default zoom level for close-up
      }
    },
    calculateDistance(pos1, pos2) {
      if (!pos1 || !pos2) return 0;

      const R = 6371; // Radius of Earth in kilometers
      const dLat = (pos2.lat - pos1.lat) * (Math.PI / 180);
      const dLng = (pos2.lng - pos1.lng) * (Math.PI / 180);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(pos1.lat * (Math.PI / 180)) * Math.cos(pos2.lat * (Math.PI / 180)) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // Distance in kilometers
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // async shareContent() {
    //   // Check if Web Share API is supported
    //   if (navigator.share) {
    //     try {
    //       // Define the content to share
    //       const shareData = {
    //         title: "Check out this page!",
    //         text: "I found something interesting here:",
    //         url: window.location.href, // Current page URL
    //       };

    //       // Trigger the share dialog
    //       await navigator.share(shareData);
    //       console.log("Successfully shared");
    //     } catch (err) {
    //       console.error("Error sharing:", err);
    //     }
    //   } else {
    //     // Fallback for browsers that don't support Web Share API
    //     this.copyUrlToClipboard();
    //   }
    // },
    //  copyUrlToClipboard1() {
    //   const text = encodeURIComponent("Check out this driver! " + window.location.href);
    //   const whatsappUrl = `https://wa.me/?text=${text}`;
    //   window.open(whatsappUrl, "_blank");
    // },
    // // Fallback: Copy the URL to the clipboard
    // copyUrlToClipboard() {
    //   const url = window.location.href;
    //   navigator.clipboard
    //     .writeText(url)
    //     .then(() => {
    //       alert(
    //         "The URL has been copied to your clipboard. You can paste it anywhere to share."
    //       );
    //     })
    //     .catch((err) => {
    //       console.error("Error copying to clipboard:", err);
    //       alert("Unable to copy the URL. Please manually share the page.");
    //     });
    // },


    testFunc() {
      const request1 = {
            origin: new google.maps.LatLng(
              this.vehiclePosition.lat,
              this.vehiclePosition.lng
            ),
            destination: new google.maps.LatLng(
              this.destination.lat,
              this.destination.lng
            ),
            travelMode: google.maps.TravelMode.DRIVING,
          };
          this.directionsService.route(request1, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
              this.directionsDisplay.setDirections(result);
              this.directionsDisplay.setMap(this.map);
                this.route = result.routes[0].overview_path.map((point) => ({
                  lat: point.lat(),
                  lng: point.lng(),
                }));
            }
          });
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

* {
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: #0a0a0b;
}

.searching-box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.searching-text {
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 21.6px;
}
.search-icon-img {
  width: 21.208px;
  height: 21.207px;
}
.page-container {
  background-color: #0d2047;
  padding: 60px 100px 100px 100px;
  display: flex;
  flex-direction: column;
  height: 100vh; /* Full viewport height */
  box-sizing: border-box; /* Include padding in width/height calculations */
  align-items: stretch;
}

.nudge-pay-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.nudge-pay-header img {
  width: 217px;
  height: 70px;
}

.booking-details-container {
  display: flex;
  background-color: #fff;
  border-radius: 24px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.booking-details-card {
  width: 55%;
}

.booking-status-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 5px;
  align-items: center;
  align-self: stretch;
}

.booking-title {
  font-size: 24px;
  font-weight: 600;
}

.booking-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 500;
}

.driver-info {
  display: flex;
  align-items: center;
}

.driver-avatar {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.driver-details {
  display: flex;
  flex-direction: column;
}

.driver-name {
  font-weight: 600;
}

.driver-rating {
  display: flex;
  align-items: center;
  width: 75px;
  height: 27px;
  border-radius: 24px;
  background-color: #ffffff;
  padding: 4px 6px 4px 6px;
}

.driver-actions {
  display: flex;
  gap: 10px;
}
.contact-button,
.share-button {
  background-color: #51d07d;
  border: none;
  border-radius: 50%;
  width: 31px;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.share-button {
  background-color: #000;
}

.star-icon {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.accepted-button {
  background-color: #79e864;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;

}
.advance-button {
  background-color: #f0d84f;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;
}
.archived-button {
  background-color: #e18d8d;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;

}
.searching-status-btn {
  background-color: #f0aa4f;
  border: none;
  color: #0a0a0b;
  border-radius: 28px;
  padding: 10px 28px 10px 28px;
  font-weight: 600;
  font-size: 18px;
  max-width: fit-content;

}

.vehicle-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 500;
}

.license-plate {
  background-color: #f0d84f;
  padding: 4px 6px 4px 6px;
  font-weight: bold;
}

.ride-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  margin-bottom: 15px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #726c6c;
}

.eta,
.distance,
.price {
  text-align: center;
}

.ride-info-heads {
  color: #726c6c;
}

.locations {
  margin-top: 20px;
}

.location-row {
  display: flex;
  align-items: center;
  background-color: #f5f7fb;
  padding: 14px 28px 14px 28px;
  border-radius: 14px;
  margin-bottom: 10px;
  font-size: 16px;
}

.pickup-row {
  height: auto;
  padding: 10px;
  border-radius: 8px;
  background-color: #ffffff;
   display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.dropoff-row {
  height: auto;
  padding: 10px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.location-icon {
  margin-right: 10px;
}

.location-icon-img {
  width: 12px;
  height: 12px;
}

.location-type {
  color: #726c6c;
  font-weight: 500;
  margin-right: 5px;
}

.separator {
  color: #726c6c;
  margin-right: 5px;
}

.location-address {
  font-weight: 400;
  color: #0a0a0b;
  flex: 1;
  word-wrap: break-word;
}

.map-container {
  width: 40%;
  padding-left: 20px;
  border-radius: 10px;
}
.map-container .vue-map-container .vue-map {
  border-radius: 15px !important;
  -webkit-border-radius: 6px;
}
.payment-color {
  color: #4c8a26;
  font-weight: 700;
}

/* Responsive Styles */
@media (max-width: 786px) {
  .page-container {
    overflow-y: auto;
    padding: 10px;
    /* Reduced padding for smaller screens */
    box-sizing: border-box;
  }
  .nudge-pay-header {
    justify-content: center;

    /* Reduced size for mobile */
  }
  .booking-details-container {
    align-items: center;
    /* Center content on smaller screens */
    flex-direction: column;
    /* Stacks content on smaller screens */
    align-items: center;

    /* Center content on smaller screens */
  }
  .booking-details-card {
    width: 100%;
    /* Full width on smaller screens */
  }
  .booking-title {
    font-size: 15px;
    /* Adjusted for mobile */
    font-weight: 600;
  }
  .booking-details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    background-color: #f5f7fb;
    padding: 5px 10px;
    /* Reduced padding for mobile */
    border-radius: 14px;
    font-size: 14px;
    /* Adjusted for mobile */
  }
  .driver-avatar {
    width: 40px;
    /* Adjusted size for mobile */
    height: 40px;
    margin-right: 10px;
  }
  .driver-rating {
    display: flex;
    align-items: center;
    width: 65px;
    /* Adjusted for mobile */
    height: 24px;
    border-radius: 24px;
    background-color: #ffffff;
    padding: 4px 6px;
  }
  .star-icon {
    width: 12px;
    /* Adjusted size for mobile */
    height: 12px;
    margin-right: 5px;
  }
  .accepted-button {
    font-size: 14px;
    /* Adjusted for mobile */
    padding: 5px 10px;
    /* Reduced padding for mobile */

    margin-top: -5px;
  }
  .advance-button {
    font-size: 14px;
    /* Adjusted for mobile */
    padding: 10px 18px;
    /* Reduced padding for mobile */

    margin-top: -5px;
  }
  .vehicle-info-row {
    padding: 10px 20px;
    /* Reduced padding for mobile */
    font-size: 14px;
    /* Adjusted for mobile */
  }
  .license-plate {
    padding: 4px 6px;
  }
  .ride-info-row {
    padding: 10px 20px;
    /* Reduced padding for mobile */
    font-size: 14px;
    /* Adjusted for mobile */
  }
  .location-row {
    font-size: 14px;
    /* Adjusted for mobile */
    padding: 10px 10px;
    /* Reduced padding for mobile */
  }
  .location-icon-img {
    margin-left: 10px;
    padding-right: 3px;
  }
  .map-container {
    width: 100%;
    padding: 0;
    display: flex;

    /* Map takes full width on mobile */
  }
  .map-container img {
    width: 100%;
    height: 280px;
    border-radius: 10px;
  }
  .pickup-row {
    padding: 8px 4px 8px 8px;
  }
  .dropoff-row {
    padding: 8px 4px 8px 8px;
  }


}
</style>
